import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef, useImperativeHandle, useCallback, useRef, } from 'react';
import clsx from 'clsx';
import _debounce from 'lodash/debounce';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { T } from '../../../i18n';
import { MenuList } from '../../components/MenuList';
export const MentionList = forwardRef(({ search, command, query, cachedMentions }, ref) => {
    const refs = useRef([]);
    const [items, setItems] = useState(cachedMentions);
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const selectItem = index => {
        const item = items === null || items === void 0 ? void 0 : items[index];
        if (item) {
            command({ id: item.id, label: item.title });
        }
    };
    const upHandler = () => {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length);
    };
    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % items.length);
    };
    const enterHandler = () => {
        selectItem(selectedIndex);
    };
    useEffect(() => setSelectedIndex(0), [items]);
    useEffect(() => {
        const el = refs.current[selectedIndex];
        if (el) {
            el.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'start',
            });
        }
    }, [selectedIndex]);
    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));
    const debounce = useCallback(_debounce((debouncedQuery) => {
        const filteredCachedMentions = (cachedMentions === null || cachedMentions === void 0 ? void 0 : cachedMentions.filter(c => c.title.toLowerCase().includes(debouncedQuery.toLowerCase()))) || [];
        const cachedMap = filteredCachedMentions === null || filteredCachedMentions === void 0 ? void 0 : filteredCachedMentions.reduce((map, mention) => ({ ...map, [mention.id]: mention }), {});
        if (typeof search === 'function') {
            setFetching(true);
            search({
                query: debouncedQuery === null || debouncedQuery === void 0 ? void 0 : debouncedQuery.replace(/[_-]/g, ' '),
            })
                .then(items => {
                const reducedResult = (items === null || items === void 0 ? void 0 : items.filter(m => !cachedMap[m.id])) || [];
                setItems([...filteredCachedMentions, ...reducedResult]);
            })
                .finally(() => {
                setFetching(false);
                setLoading(false);
            });
        }
    }, 300), []);
    useEffect(() => {
        const cachedItems = cachedMentions === null || cachedMentions === void 0 ? void 0 : cachedMentions.filter(c => c.title.toLowerCase().includes(query.toLowerCase()));
        setLoading(true);
        if (cachedItems) {
            setItems(cachedItems);
        }
        debounce(query);
    }, [query, debounce, cachedMentions]);
    if (!(items === null || items === void 0 ? void 0 : items.length) && !query) {
        return null;
    }
    if (Array.isArray(items) && !(items === null || items === void 0 ? void 0 : items.length) && !loading && !fetching) {
        return (_jsx(MenuList, { children: _jsx("p", { className: "text-center bg-surface text-content flex items-center px-4 py-2 space-s-2", children: _jsx(T, { id: "Composer.Mention.NotFoundErrorMessage", defaultMessage: "Couldn\u2019t find any match" }, void 0) }, void 0) }, void 0));
    }
    return (_jsxs(MenuList, { children: [items === null || items === void 0 ? void 0 : items.map((item, index) => (_jsxs("span", { ref: el => {
                    refs.current[index] = el;
                }, className: clsx(index === selectedIndex
                    ? 'bg-surface-subdued text-content'
                    : 'bg-surface text-content', 'flex items-center px-4 py-2 space-s-2', 'cursor-pointer'), onClick: () => selectItem(index), children: [_jsx(Avatar, { size: "xs", src: item.icon, name: item.title }, void 0), _jsx("p", { className: "ms-2 truncate", children: item.title }, void 0)] }, item.id))), fetching && (_jsx("div", { className: clsx('flex justify-center items-center px-4 py-2', !(items === null || items === void 0 ? void 0 : items.length) && 'w-28'), children: _jsx(SpinnerIcon, { className: "animate-spin" }, void 0) }, void 0))] }, void 0));
});
//# sourceMappingURL=List.js.map